import { Context } from '@front10/helpers/dist/Context';
import React, { useContext } from 'react';
import Button from '../../../elements/Button';
import { ButtonProps } from '../../../elements/Button/Button';
import { StyledProps } from '@front10';

interface Props {
  labelKey?: string;
  moreInformationLink: string;
  moreInformationCallToActionStyles?: StyledProps;
  onStationClick?: (station: $TSFixMe, callToActionLabel: string) => void;
}

function MoreInformationCallToAction({
  moreInformationLink,
  moreInformationCallToActionStyles = {},
  onStationClick = (station, callToActionLabel) => {},
  labelKey = 'cmp-bus-directory-map-more-information-call-to-action'
}: Omit<ButtonProps, 'color' | 'tabIndex'> & Props) {
  const { translate } = useContext(Context);
  return (
    <>
      <Button
        color={'primary'}
        {...moreInformationCallToActionStyles}
        onClick={() => {
          window.open(moreInformationLink, '_top');
        }}
      >
        {translate(labelKey, 'More information')}
      </Button>
    </>
  );
}

MoreInformationCallToAction.componentName = 'MoreInformationCallToAction';

export default MoreInformationCallToAction;
